import { darkColors } from '@tryhackme/thm-ui-components';
import { useGetUserQuery } from 'src/common/slices';
import { ThemeProvider, useTheme } from 'styled-components';
import { Countdown } from '../../components/countdown';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { useGetAfterSignupFlashSaleEndTime } from '../../hooks/use-get-after-signup-flash-sale-end-time';
import { StyledCard, StyledTimerMessage, StyledTitle } from './account-card.styles';
export const AfterSignupFlashSaleAccountCard = () => {
  const theme = useTheme();
  const {
    campaign
  } = useActiveCampaign();
  const {
    data: userDataResponse
  } = useGetUserQuery();
  const flashSaleEndTime = useGetAfterSignupFlashSaleEndTime(campaign, userDataResponse?.data?.user?.dateSignUp);
  if (!campaign) return null;
  return <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="AfterSignupFlashSaleAccountCard" data-sentry-source-file="account-card.tsx">
      <StyledCard data-sentry-element="StyledCard" data-sentry-source-file="account-card.tsx">
        <StyledTitle data-testid="campaign-account-card" data-sentry-element="StyledTitle" data-sentry-source-file="account-card.tsx">
          LEVEL UP YOUR LEARNING: <span>25% OFF</span> ANNUAL SUBSCRIPTIONS
        </StyledTitle>
        <StyledTimerMessage data-sentry-element="StyledTimerMessage" data-sentry-source-file="account-card.tsx">Sale ends in:</StyledTimerMessage>
        <Countdown dark vertical includeDays endTime={flashSaleEndTime} data-sentry-element="Countdown" data-sentry-source-file="account-card.tsx" />
      </StyledCard>
    </ThemeProvider>;
};